<td class="py-1 px-2 employee-init position-sticky start-0 text-center bg-light z-1" [title]="user.brugerId">
    <span class="employee-avatar bg-secondary-subtle text-primary fw-medium rounded-circle overflow-hidden flex-shrink-0 d-inline-flex align-items-center justify-content-center" [attr.aria-label]="user.brugerId">{{ initials }}</span>
</td>
<td class="py-1 px-2 employee-field">{{ user.fornavn }} {{ user.efternavn }}</td>

<td class="py-1 px-2 employee-field">
    <ng-select [items]="indexCardsStore.titler()"
               bindLabel="val"
               bindValue="id"
               [ariaLabel]="'Titel – ' + user.brugerId" [ngModel]="user.titel"
               (ngModelChange)="updateTitel(user.cardId, $event)"
               class="ng-select-sm employee-select" appendTo=".employee-dropdown-host" dropdownPosition="auto"
               [clearable]="false"
               [searchable]="false">
    </ng-select>
</td>

<td class="py-1 px-2 employee-field">
    <input class="form-control form-control-sm text-end" type="text" (keydown.enter)="$any($event.target).blur()"
           [attr.aria-label]="'Telefon – ' + user.brugerId" [ngModel]="user.telefondirekte"
           [ngModelOptions]="{ updateOn: 'blur' }"
           (ngModelChange)="onTelefonDirektChange(user.cardId, $event)">
</td>

<td class="py-1 px-2 employee-field">
    <input class="form-control form-control-sm text-end" type="text" (keydown.enter)="$any($event.target).blur()"
           [ngModelOptions]="{ updateOn: 'blur' }"
           [attr.aria-label]="'Mobil – ' + user.brugerId" [ngModel]="user.telefonmobil"
           (ngModelChange)="onTelefonMobilChange(user.cardId, $event)">
</td>

<td class="py-1 px-2 employee-field">{{ user.email }}</td>

<td class="py-1 px-2 employee-flag text-center">
    <input class="form-check-input" type="checkbox"
           [attr.aria-label]="'SA – ' + user.brugerId" [ngModel]="user.sagsbehandler"
           (ngModelChange)="updateSagsbehandler(user.cardId, $event)">
</td>

<td class="py-1 px-2 employee-flag text-center">
    <input class="form-check-input" type="checkbox"
           [attr.aria-label]="'KA – ' + user.brugerId" [ngModel]="user.kundeansvarlig"
           (ngModelChange)="updateKundeansvarlig(user.cardId, $event)">
</td>

<td class="py-1 px-2 employee-flag text-center">
    <input class="form-check-input" type="checkbox"
           [attr.aria-label]="'LA – ' + user.brugerId" [ngModel]="user.ledelsesansvarlig"
           (ngModelChange)="updateLedelsesansvarlig(user.cardId, $event)">
</td>

@for (rate of rateColumns; track rate.ts) {
    <td class="py-1 px-2 employee-rate text-end" [class.rate-invalid]="rateErrors.has(rate.field)">
        <input class="form-control form-control-sm text-end" type="text" inputmode="numeric"
               [attr.aria-label]="'Timesats: ' + rate.name + ' – ' + user.brugerId"
               [attr.aria-invalid]="rateErrors.has(rate.field)"
               [attr.aria-describedby]="rateErrors.has(rate.field) ? 'rate-error-' + user.cardId + '-' + rate.ts : null"
               [attr.title]="rateErrors.has(rate.field) ? 'Angiv en timesats i hele kroner (0 eller højere).' : null"
               placeholder="—"
               [ngModel]="user[rate.field]" [ngModelOptions]="{ updateOn: 'blur' }"
               (keydown.enter)="$any($event.target).blur()"
               (ngModelChange)="onTimesatsChange(user.cardId, rate.field, $event)">
        @if (rateErrors.has(rate.field)) {
            <span class="visually-hidden" role="alert" [id]="'rate-error-' + user.cardId + '-' + rate.ts">Angiv en timesats i hele kroner (0 eller højere).</span>
        }
    </td>
}

<td class="py-1 px-2 employee-level">
    <ng-select [items]="[1, 2, 3, 4]"
                              [ariaLabel]="'Level – ' + user.brugerId" [ngModel]="user.lev"
               (ngModelChange)="updateLev(user.cardId, $event)"
               class="ng-select-sm employee-select" appendTo=".employee-dropdown-host" dropdownPosition="auto"
               [clearable]="false"
               [searchable]="false"
               placeholder="Level">
    </ng-select>
</td>

<td class="py-1 px-2 employee-field">
    <app-date-picker-dk [ngModel]="user.ansaettelsesdato | date:'yyyy-MM-dd'"
                        (ngModelChange)="onAnsaettelsesdatoChange(user.cardId, $event)">
    </app-date-picker-dk>
</td>

<td class="py-1 px-2 employee-field">
    <app-date-picker-dk [ngModel]="user.foedselsdato | date:'yyyy-MM-dd'"
                        (ngModelChange)="onFoedselsdatoChange(user.cardId, $event)">
    </app-date-picker-dk>
</td>

<td class="py-1 px-2 employee-field">
    <app-date-picker-dk [ngModel]="user.fratraadt | date:'yyyy-MM-dd'"
                        (ngModelChange)="onFratraadtChange(user.cardId, $event)">
    </app-date-picker-dk>
</td>

<td class="py-1 px-2 employee-field">
    <ng-select [items]="indexCardsStore.afdelinger()"
               bindLabel="afdelingsnavn"
               bindValue="id"
               placeholder="Ingen"
               [ariaLabel]="'Afdeling – ' + user.brugerId" [ngModel]="user.afdeling || null"
               (ngModelChange)="updateAfdeling(user.cardId, $event)"
               class="ng-select-sm employee-select" appendTo=".employee-dropdown-host" dropdownPosition="auto"
               [clearable]="false"
               [searchable]="false">
    </ng-select>
</td>

<td class="py-1 px-2 employee-field">
    <ng-select [items]="indexCardsStore.grupper()"
               [ariaLabel]="'Grupper – ' + user.brugerId" bindLabel="gruppe"
               bindValue="id"
               class="ng-select-sm employee-select" appendTo=".employee-dropdown-host" dropdownPosition="auto"
               [closeOnSelect]="false" [clearable]="false" [searchable]="false"
               placeholder="Ingen" [multiple]="true"
               [ngModel]="getGrupperNumbers()"
               (ngModelChange)="updateGrupper(user.cardId, $event)">
        <ng-template ng-multi-label-tmp let-items="items">
            <span class="d-block text-truncate w-100" [title]="groupSummary(items)">{{ groupSummary(items) }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <span class="d-flex align-items-center justify-content-between gap-2">
                <span class="text-truncate">{{ groupLabel(item) }}</span>
                @if (item$.selected) {
                    <i class="fa fa-check flex-shrink-0" aria-hidden="true"></i>
                }
            </span>
        </ng-template>
    </ng-select>
</td>
